<!-- 车辆扫通道二维码自助进出场 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KM43Y461",
                "channelSeq": 1,
                "userUniqCode":"1231231231"
            },
            responseCode: {
                "data": {
                    "parkCode": "",
                    "channelSeq": "",
                    "passType": "",
                    "isParkInOut": "",
                    "isPaid": "",
                    "code": "",
                    "msg": "",
                    "parkingCode": "",
                    "amount": "",
                    "carCode": "",
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台，使得车辆扫通道二维码自助进出场（车辆可以是无牌车，也可以是有牌车）",
                t_url: this.commonUrls.test+"scanChannelCodeInOut",
                p_url: this.commonUrls.prod+"scanChannelCodeInOut",
                flow: '/static/img/第三方通道二维码流程.png',
                precondition: "vems通道配置，选择支持自助开闸",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'channelSeq', info2: '是', info3: 'Long', info4: '通道ID' },//可通过getParkEquipmentInfo接口的entranceChannelSeq获取
                        { info1: 'userUniqCode', info2: '是', info3: 'String', info4: '第三方所属用户的唯一编码' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        // { info1: 'selfInRandomCode', info2: '是', info3: 'String', info4: '自助进场随机码' },
                        // { info1: 'selfOutRandomCode', info2: '否', info3: 'String', info4: '自助离场随机码' },
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'channelSeq', info2: '是', info3: 'String', info4: '通道ID' },
                        { info1: 'passType', info2: '是', info3: 'Integer', info4: '进出类型 1：进场 2：出场' },
                        { info1: 'isParkInOut ', info2: '是', info3: 'Integer', info4: '是否整个停车场 0：否 1：是' },
                        { info1: 'isPaid', info2: '是', info3: 'Integer', info4: '是否已付费 0:否 1：是' },
                        { info1: 'code', info2: '是', info3: 'Integer', info4: '返回码 0:成功 1:匹配不到进场随机码 2:匹配不到离场随机码 3:未缴费 4:找不到指定的自助码 5:开闸失败 6:已存在关联的自助进场记录 7:找不到指定的停车场 8:当前通道没有车辆 9:查费失败 10:当前通道没有开启自助开闸功能' },
                        { info1: 'msg', info2: '是', info3: 'String', info4: '返回消息' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车唯一编码（在进场通道处调用该接口，字段为空）' },
                        { info1: 'amount', info2: '否', info3: 'Decimal', info4: '需缴费金额，单位：元' },
                        { info1: 'carCode', info2: '否', info3: 'String', info4: '车牌号码' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/scanChannelCodeInOut.vue